import type { CrmReportProblemTicket, CrmTicketDto } from './APITypes';

export const ticketAPIToTicket = (apiTicket: any): CrmTicketDto | null => {
  const isNullOrEmpty = (value: string | undefined | null) => {
    if (value?.trim() === '' || value === undefined) return null;

    return value;
  };

  const isNumberNullOrEmpty = (value: number | undefined | null) => {
    if (value === null || value === undefined) return null;

    return value;
  };

  if (!apiTicket) return null;

  return {
    id: apiTicket.id,
    originTicketId: isNullOrEmpty(apiTicket.originTicketId),

    shippingInformation: {
      trackingCode: isNullOrEmpty(apiTicket.shipping_information.tracking_code),
      shippingCompany: isNullOrEmpty(apiTicket.shipping_information.shipping_company),
      shippingCompanyLink: isNullOrEmpty(apiTicket.shipping_information.shipping_company_link),
      addressInformation: {
        addressConfirmation: isNullOrEmpty(apiTicket.shipping_information.address_information.address),
        postalCode: isNullOrEmpty(apiTicket.shipping_information.address_information.zip_code),
      },
      estimatedReceivingDate: isNullOrEmpty(apiTicket.shipping_information.estimated_receiving_date),
      deviceInformation: {
        quantidadeEnvioInstaladoLevesBloqueador: isNumberNullOrEmpty(apiTicket.shipping_information.device_information.quantidade_envio_instalado_leves_bloqueador),
        quantidadeEnvioInstaladoLevesOuPesados: isNumberNullOrEmpty(apiTicket.shipping_information.device_information.quantidade_envio_instalado_leves_ou_pesados),
        quantidadeEnvioInstaladoLevesOuPesadosCobliCamGeracao2: isNumberNullOrEmpty(
          apiTicket.shipping_information.device_information.quantidade_envio_instalado_leves_ou_pesados_cobli_cam_geracao_2
        ),
        quantidadeEnvioInstaladoLevesOuPesadosCobliCamGeracao2Pro: isNumberNullOrEmpty(
          apiTicket.shipping_information.device_information.quantidade_envio_instalado_leves_ou_pesados_cobli_cam_geracao_2_pro
        ),
        quantidadeEnvioInstaladoLevesOuPesadosCliente: isNumberNullOrEmpty(apiTicket.shipping_information.device_information.quantidade_envio_instalado_leves_ou_pesados_cliente),
        quantidadeEnvioInstaladoLevesOuPesadosCobliCam: isNumberNullOrEmpty(
          apiTicket.shipping_information.device_information.quantidade_envio_instalado_leves_ou_pesados_cobli_cam
        ),
        quantidadeEnvioInstaladoLevesOuPesadosIdentificador: isNumberNullOrEmpty(
          apiTicket.shipping_information.device_information.quantidade_envio_instalado_leves_ou_pesados_identificador
        ),
        quantidadeEnvioInstaladoLevesOuPesadosImobilizador: isNumberNullOrEmpty(
          apiTicket.shipping_information.device_information.quantidade_envio_instalado_leves_ou_pesados_imbolizador
        ),
        quantidadeEnvioInstaladoMotosOuMaquinarios: isNumberNullOrEmpty(apiTicket.shipping_information.device_information.quantidade_envio_instalado_motos_ou_maquinarios),
        quantidadeEnvioInstaladoMotosOuMaquinariosCliente: isNumberNullOrEmpty(
          apiTicket.shipping_information.device_information.quantidade_envio_instalado_motos_ou_maquinarios_cliente
        ),
        quantidadeEnvioRemovivelLeves: isNumberNullOrEmpty(apiTicket.shipping_information.device_information.quantidade_envio_removivel_leves),
        quantidadeEnvioRemovivelLevesOuPesadosBuzzer: isNumberNullOrEmpty(apiTicket.shipping_information.device_information.quantidade_envio_removivel_leves_ou_pesados_buzzer),
        quantidadeEnvioRemovivelLevesOuPesadosIdentificador: isNumberNullOrEmpty(
          apiTicket.shipping_information.device_information.quantidade_envio_removivel_leves_ou_pesados_identificador
        ),
        quantidadeEnvioRemovivelPesados: isNumberNullOrEmpty(apiTicket.shipping_information.device_information.quantidade_envio_removivel_pesados),
        quantidadeChaveiro: isNumberNullOrEmpty(apiTicket.shipping_information.device_information.quantidade_chaveiro),
        shippingDevicesCobliIds: apiTicket.shipping_information.device_information.shipping_devices_cobli_ids,
        shippingDevicesIds: apiTicket.shipping_information.device_information.shipping_devices_ids,
      },
    },

    installationInformation: {
      contactInformation: {
        bestWayOfContact: isNullOrEmpty(apiTicket.installation_information.contact_information.best_way_of_contact),
        bestTimeToContact: isNullOrEmpty(apiTicket.installation_information.contact_information.best_time_to_contact),
        meansToContact: isNullOrEmpty(apiTicket.installation_information.contact_information.means_to_contact),
        meansToContactTheResponsibleForInstallation: isNullOrEmpty(apiTicket.installation_information.contact_information.means_to_contact_the_responsible_for_installation),
      },
      clientInformation: {
        email: isNullOrEmpty(apiTicket.installation_information.client_information.email),
        phoneNumber: isNullOrEmpty(apiTicket.installation_information.client_information.phone_number),
        name: isNullOrEmpty(apiTicket.installation_information.client_information.name),
        responsibleForTrackingScheduling: isNullOrEmpty(apiTicket.installation_information.client_information.responsible_for_tracking_scheduling),
        installationDoneByClient: apiTicket.installation_information.client_information.installation_done_by_client,
        installationProblem: isNullOrEmpty(apiTicket.installation_information.client_information.installation_problem),
      },
      deviceInformation: {
        installationEsns: isNullOrEmpty(apiTicket.installation_information.device_information.installation_esns),
        installationInstalledEsns: isNullOrEmpty(apiTicket.installation_information.device_information.installation_installed_esns),
        installationNotInstalledEsns: isNullOrEmpty(apiTicket.installation_information.device_information.installation_not_installed_esns),
        type: isNullOrEmpty(apiTicket.installation_information.device_information.type),
        esnToInstall: isNullOrEmpty(apiTicket.installation_information.device_information.esn_to_install),
        esnToNotInstall: isNullOrEmpty(apiTicket.installation_information.device_information.esn_to_not_install),
        heavyOrLightVehiclesInstalledIdentifierQuantity: isNumberNullOrEmpty(
          apiTicket.installation_information.device_information.heavy_or_light_vehicles_installed_identifier_quantity
        ),
        heavyOrLightVehiclesInstalledImmobilizerQuantity: isNumberNullOrEmpty(
          apiTicket.installation_information.device_information.heavy_or_light_vehicles_installed_immobilizer_quantity
        ),
        heavyOrLightVehiclesInstalledQuantityCoblicam: isNumberNullOrEmpty(
          apiTicket.installation_information.device_information.heavy_or_light_vehicles_installed_quantity_coblicam
        ),
        heavyOrLightVehiclesInstalledQuantity: isNumberNullOrEmpty(apiTicket.installation_information.device_information.heavy_or_light_vehicles_installed_quantity),
        lightVehiclesInstalledBlockerQuantity: isNumberNullOrEmpty(apiTicket.installation_information.device_information.light_vehicles_installed_blocker_quantity),
        motorcyclesOrHeavyVehiclesInstalledQuantity: isNumberNullOrEmpty(apiTicket.installation_information.device_information.motorcycles_or_heavy_vehicles_installed_quantity),
        calculatedInstallDevices: isNumberNullOrEmpty(apiTicket.installation_information.device_information.calculated_installed_ticket),
        installationDevicesCobliIds: apiTicket.installation_information.device_information.installation_devices_cobli_ids,
        installationDevicesIds: apiTicket.installation_information.device_information.installation_devices_ids,
      },
      dateInformation: {
        scheduledDay: isNullOrEmpty(apiTicket.installation_information.date_information.scheduled_day),
        clientFirstPreferredScheduleDay: isNullOrEmpty(apiTicket.installation_information.date_information.client_first_preferred_schedule_day),
        clientSecondPreferredScheduleDay: isNullOrEmpty(apiTicket.installation_information.date_information.client_second_preferred_schedule_day),
        scheduledDateTime: isNullOrEmpty(apiTicket.installation_information.date_information.scheduled_date_time),
        clientFirstPreferredScheduleHour: isNullOrEmpty(apiTicket.installation_information.date_information.client_first_preferred_schedule_hour),
        clientSecondPreferredScheduleHour: isNullOrEmpty(apiTicket.installation_information.date_information.client_second_preferred_schedule_hour),
        installedDate: isNullOrEmpty(apiTicket.installation_information.date_information.installed_date),
        installationConfirmedAt: isNullOrEmpty(apiTicket.installation_information.date_information.installation_confirmed_at),
      },
      coblerInformation: {
        responsible: isNullOrEmpty(apiTicket.installation_information.cobler_information.responsible),
        responsibleScheduling: isNullOrEmpty(apiTicket.installation_information.cobler_information.responsible_scheduling),
        responsibleToContactClient: isNullOrEmpty(apiTicket.installation_information.cobler_information.responsible_to_contact_client),
        technicalResponsible: isNullOrEmpty(apiTicket.installation_information.cobler_information.technical_responsible),
      },
      fieldControlInformation: {
        worker: isNullOrEmpty(apiTicket.installation_information.field_control_information.worker),
        fieldControlObservation: isNullOrEmpty(apiTicket.installation_information.field_control_information.field_control_observation),
        observationToTheTechnicalTeam: isNullOrEmpty(apiTicket.installation_information.field_control_information.observation_to_the_technical_team),
        fieldAssociation: isNullOrEmpty(apiTicket.installation_information.field_control_information.field_association),
        fieldClass: isNullOrEmpty(apiTicket.installation_information.field_control_information.field_class),
        supplyInstalacaoClasse: isNullOrEmpty(apiTicket.installation_information.field_control_information.supply_instalacao_classe),
      },
      addressInformation: {
        postalCode: isNullOrEmpty(apiTicket.installation_information.address_information.postal_code),
        addressConfirmation: isNullOrEmpty(apiTicket.installation_information.address_information.address_confirmation),
      },
      vehicleInformation: {
        plack: isNullOrEmpty(apiTicket.installation_information.vehicle_information.plack),
        vehicles: isNullOrEmpty(apiTicket.installation_information.vehicle_information.vehicles),
      },
      responsibleUser: {
        id: isNullOrEmpty(apiTicket.installation_information.responsible_user?.id),
        name: isNullOrEmpty(apiTicket.installation_information.responsible_user?.name),
        email: isNullOrEmpty(apiTicket.installation_information.responsible_user?.email),
        fleetIds: apiTicket.installation_information.responsible_user?.fleet_ids.map((fleet_id: string | null) => isNullOrEmpty(fleet_id)),
        createdAt: isNullOrEmpty(apiTicket.installation_information.responsible_user?.created_at),
        updatedAt: isNullOrEmpty(apiTicket.installation_information.responsible_user?.updated_at),
      },

      ratedAt: isNullOrEmpty(apiTicket.installation_information.rated_at),
      fleetId: isNullOrEmpty(apiTicket.installation_information.fleet_id),
      scheduledDay: isNullOrEmpty(apiTicket.installation_information.scheduled_day),
      scheduledDateTime: isNullOrEmpty(apiTicket.installation_information.scheduled_date_time),
      installedDate: isNullOrEmpty(apiTicket.installation_information.installed_date),
      installationConfirmedAt: isNullOrEmpty(apiTicket.installation_information.installation_confirmed_at),
      notResponsible: apiTicket.installation_information.not_responsible,
    },

    devolutionInformation: {
      fleetId: isNullOrEmpty(apiTicket.devolution_information.fleet_id),
      fleetName: isNullOrEmpty(apiTicket.devolution_information.fleet_name),
      type: isNullOrEmpty(apiTicket.devolution_information.type),
      penaltyPrice: isNumberNullOrEmpty(apiTicket.devolution_information.penalty_price),
      devolutionDeadline: isNullOrEmpty(apiTicket.devolution_information.devolution_deadline),
      supplyDevolucaoTipo: isNullOrEmpty(apiTicket.devolution_information.supply_devolucao_tipo),
      clientInformation: {
        clientCnpj: isNullOrEmpty(apiTicket.devolution_information.client_information.client_cnpj),
      },
      shippingInformation: {
        devolutionPostageDate: isNullOrEmpty(apiTicket.devolution_information.shipping_information.devolution_postage_date),
        devolutionArrivalOfDevicesAtCobli: isNullOrEmpty(apiTicket.devolution_information.shipping_information.devolution_arrival_of_devices_at_cobli),
        devolutionShippingCodeOrScheduleDate: isNullOrEmpty(apiTicket.devolution_information.shipping_information.devolution_shipping_code_or_schedule_date),
        devolutionShippingCode: isNullOrEmpty(apiTicket.devolution_information.shipping_information.devolution_shipping_code),
        devolutionShippingType: isNullOrEmpty(apiTicket.devolution_information.shipping_information.devolution_shipping_type),
      },
      deviceInformation: {
        devolutionDevicesCobliIds: apiTicket.devolution_information.device_information.devolution_devices_cobli_ids,
        devolutionDevicesIds: apiTicket.devolution_information.device_information.devolution_devices_ids,
        devolutionDevicesEsn: isNullOrEmpty(apiTicket.devolution_information.device_information.devolution_devices_esn),
        lightDevolutionInstalledBlockerQuantity: isNumberNullOrEmpty(apiTicket.devolution_information.device_information.light_devolution_installed_blocker_quantity),
        heavyOrLightDevolutionInstalledQuantity: isNumberNullOrEmpty(apiTicket.devolution_information.device_information.heavy_or_light_devolution_installed_quantity),
        heavyOrLightDevolutionInstalledBuzzerQuantity: isNumberNullOrEmpty(apiTicket.devolution_information.device_information.heavy_or_light_devolution_installed_buzzer_quantity),
        heavyOrLightDevolutionInstalledCoblicamQuantity: isNumberNullOrEmpty(
          apiTicket.devolution_information.device_information.heavy_or_light_devolution_installed_coblicam_quantity
        ),
        heavyOrLightDevolutionInstalledImmobilizerQuantity: isNumberNullOrEmpty(
          apiTicket.devolution_information.device_information.heavy_or_light_devolution_installed_immobilizer_quantity
        ),
        motorcycleOrMachineryDevolutionInstalledQuantity: isNumberNullOrEmpty(
          apiTicket.devolution_information.device_information.motorcycle_or_machinery_devolution_installed_quantity
        ),
        lightDevolutionRemovableQuantity: isNumberNullOrEmpty(apiTicket.devolution_information.device_information.light_devolution_removable_quantity),
        heavyDevolutionRemovableQuantity: isNumberNullOrEmpty(apiTicket.devolution_information.device_information.heavy_devolution_removable_quantity),
        heavyOrLightDevolutionRemovableBuzzerQuantity: isNumberNullOrEmpty(apiTicket.devolution_information.device_information.heavy_or_light_devolution_removable_buzzer_quantity),
        heavyOrLightDevolutionRemovableIdentifierQuantity: isNumberNullOrEmpty(
          apiTicket.devolution_information.device_information.heavy_or_light_devolution_removable_identifier_quantity
        ),
        motorcycleOrMachineryDevolutionInstalledClientQuantity: isNumberNullOrEmpty(
          apiTicket.devolution_information.device_information.motorcycle_or_machinery_devolution_installed_client_quantity
        ),
        heavyOrLightDevolutionInstalledIdentifierQuantity: isNumberNullOrEmpty(
          apiTicket.devolution_information.device_information.heavy_or_light_devolution_installed_identifier_quantity
        ),
      },
    },

    servicos: {
      supplyDesinstalacaoCalculoTotal: isNumberNullOrEmpty(apiTicket.servicos.supplyDesinstalacaoCalculoTotal),
      csAbanQtdDesinstalacao2630Bloqueador: isNumberNullOrEmpty(apiTicket.servicos.csAbanQtdDesinstalacao2630Bloqueador),
      csAbanQtdDesinstalacao2630: isNumberNullOrEmpty(apiTicket.servicos.csAbanQtdDesinstalacao2630),
      quantidadeDesinstalacaoInstaladoLevesOuPesadosCameraFadiga: isNumberNullOrEmpty(apiTicket.servicos.quantidadeDesinstalacaoInstaladoLevesOuPesadosCameraFadiga),
      quantidadeDesinstalacaoInstaladoLevesOuPesadosCameraFadigaPremium: isNumberNullOrEmpty(apiTicket.servicos.quantidadeDesinstalacaoInstaladoLevesOuPesadosCameraFadigaPremium),
      coAbanQtdDesinstalacaoInstaladoVeiculosLevesOuPesadosCliente: isNumberNullOrEmpty(apiTicket.servicos.coAbanQtdDesinstalacaoInstaladoVeiculosLevesOuPesadosCliente),
      coAbanQtdDesinstalacaoInstaladoVeiculosLevesOuPesadosCoblicam: isNumberNullOrEmpty(apiTicket.servicos.coAbanQtdDesinstalacaoInstaladoVeiculosLevesOuPesadosCoblicam),
      csAbanQtdDesinstalacao2630Ibutton: isNumberNullOrEmpty(apiTicket.servicos.csAbanQtdDesinstalacao2630Ibutton),
      quantidadeDesinstalacaoInstaladoLevesOuPesadosBuzzer: isNumberNullOrEmpty(apiTicket.servicos.quantidadeDesinstalacaoInstaladoLevesOuPesadosBuzzer),
      csAbanQtdDesinstalacao2130: isNumberNullOrEmpty(apiTicket.servicos.csAbanQtdDesinstalacao2130),
      coAbanQtdDesinstalacaoInstaladoMotosOuMaquinariosCliente: isNumberNullOrEmpty(apiTicket.servicos.csAbanQtdDesinstalacao3030),
      csAbanQtdDesinstalacao3030: isNumberNullOrEmpty(apiTicket.servicos.csAbanQtdDesinstalacao3030),
      quantidadeDesinstalacaoRemovivelLevesOuPesadosBuzzer: isNumberNullOrEmpty(apiTicket.servicos.quantidadeDesinstalacaoRemovivelLevesOuPesadosBuzzer),
      quantidadeDesinstalacaoRemovivelLevesOuPesadosIdentificador: isNumberNullOrEmpty(apiTicket.servicos.quantidadeDesinstalacaoRemovivelLevesOuPesadosIdentificador),
      coAbanQtdDesinstalacaoRemovivelVeiculosPesados: isNumberNullOrEmpty(apiTicket.servicos.coAbanQtdDesinstalacaoRemovivelVeiculosPesados),
    },

    closedDate: isNullOrEmpty(apiTicket.closed_date),
    content: isNullOrEmpty(apiTicket.content),
    createDate: isNullOrEmpty(apiTicket.create_date),
    conclusionDate: isNullOrEmpty(apiTicket.conclusion_date),
    lastActivityDate: isNullOrEmpty(apiTicket.last_activity_date),
    lastModifiedDate: isNullOrEmpty(apiTicket.last_modified_date),
    nextActivityDate: isNullOrEmpty(apiTicket.next_activity_date),
    pipeline: isNullOrEmpty(apiTicket.pipeline),
    pipelineStage: isNullOrEmpty(apiTicket.pipeline_stage),
    priority: isNullOrEmpty(apiTicket.priority),
    notesLastUpdated: isNullOrEmpty(apiTicket.notes_last_updated),
    notesNextActivityDate: isNullOrEmpty(apiTicket.notes_next_activity_date),
    sourceType: isNullOrEmpty(apiTicket.source_type),
    subject: isNullOrEmpty(apiTicket.subject),
    ticketAssociatedDealId: isNullOrEmpty(apiTicket.ticket_associated_deal_id),
    resolution: isNullOrEmpty(apiTicket.resolution),
    panelFormTest: apiTicket.panel_form_test,
  };
};

export const ticketAPIToReportProblemTicket = (reportProblemRequest: any): CrmReportProblemTicket => {
  return {
    id: reportProblemRequest.id,
    createdAt: reportProblemRequest.create_date,
    properties: {
      subject: reportProblemRequest.subject,
    },
  };
};
